module.exports = __webpack_public_path__ + "static/img/stamp2.da1dc7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/styles/mailkit/img/stamp2.jpg
// module id = i2LE
// module chunks = 1